import { useIntl } from 'react-intl';

export default () => {
  const intl = useIntl();
  return {
    ...intl,
    translate: (id, values) => intl.formatMessage({ id }, values),
  };
};
